import { Colors, Language, Lightning, Router, VideoPlayer } from '@lightningjs/sdk'
import Button from '../components/buttons/Button'
import PlayButton from '../components/buttons/PlayButton'
import AlbumCover from '../components/coverItems/AlbumCover'
import LargeText from '../components/LargeText'
import { cleanHtml } from '../lib/AppHelpers'

export default class PlaylistDetail extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('PageBG').get(),
      AlbumCover: { w: 579, h: 579, x: 355, y: 251, pivot: 0, type: AlbumCover },
      InfoWrapper: {
        w: 800,
        h: 800,
        x: 1013,
        y: 330,
        Title: {
          w: 1050,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('title'),
            fontSize: 62,
            fontFace: 'OpenSansBold',
            lineHeight: 65,
            wordWrapWidth: 800,
            maxLines: 2,
            textOverflow: 'ellipsis',
          },
        },
        ByName: {
          w: 800,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('byName'),
            fontSize: 25,
            lineHeight: 40,
            fontFace: 'OpenSansLight',
          },
        },
        DescrWrapper: {
          w: 800,
          h: 85,
          DescrSmall: {
            w: 800,
            color: Colors('white').get(),
            alpha: 1,
            text: {
              text: this.bindProp('descrSmall'),
              fontSize: 28,
              lineHeight: 40,
              wordWrapWidth: 800,
              fontFace: 'OpenSansRegular',
              maxLines: 2,
              textOverflow: 'ellipsis',
            },
          },
          DescrLarge: { x: -40, w: 800, h: 305, alpha: 0.001, type: LargeText, clipbox: false },
        },
        ButtonWrapper: {
          w: 800,
          h: 80,
          PlayButton: {
            type: PlayButton,
            buttonType: 'playstop',
            icon: 'PlayerButtonPlay',
            size: 80,
          },
          Readmore: {
            w: 200,
            h: 60,
            x: 116,
            y: 10,
            type: Button,
            buttonText: Language.translate('Readmore'),
            padding: 5,
          },
        },
      },
    }
  }

  set items(data) {
    this._item = data

    const descr = cleanHtml(this._item.description)

    this.patch({
      title: this._item.title,
      byName: '', //todo: notavailable in api
      descrSmall: descr,
      // AlbumCover: {item: this._item.image}
      AlbumCover: { itemBg: this._item.image }, // TODO
    })
    this.tag('PlayButton').butnType =
      VideoPlayer.playing && VideoPlayer.src === this._item.streamUrl ? 'stop' : 'playstop'

    this.tag('DescrLarge').detailtext = descr
  }

  set autoPlay(v) {
    this._autoPlay = v
  }

  pageTransition() {
    return 'fade'
  }

  _init() {
    this._descrCollaps = true

    this.widgets['sidemenu'].activeMenuItem = 2
    this.tag('Title').on('txLoaded', () => {
      this.tag('DescrWrapper').y = this.tag('Title').y + this.tag('Title').finalH + 20
      this.tag('ButtonWrapper').y =
        this.tag('Title').y + this.tag('Title').finalH + 20 + this.tag('DescrSmall').finalH + 40
    })
    this.tag('DescrSmall').on('txLoaded', () => {
      let _initBtY = this.tag('DescrWrapper').y + this.tag('DescrSmall').finalH + 40
      if (!this._btnYposSet) {
        this.tag('ButtonWrapper').y = _initBtY
        this._btnYposSet = true
      }
      this.largeTextDims = this.tag('DescrLarge').dimensions

      this._showScroller = this.largeTextDims.height >= 305

      this.tag('Readmore').visible =
        this.tag('DescrSmall').finalH > 190 ||
        this.tag('DescrSmall').text.source.renderInfo.moreTextLines

      if (this.largeTextDims.height < 305) {
        this.tag('DescrLarge').h = this.largeTextDims.height
      }
      if (!this._expandAnimation) {
        this._expandAnimation = this.animation({
          duration: 0.4,
          repeat: 0,
          stopMethod: 'reverse',
          stopDuration: 0.3,
          actions: [
            { t: 'InfoWrapper', p: 'y', v: { 0: 330, 1: 235 } },
            { t: 'ButtonWrapper', p: 'y', v: { 0: _initBtY, 1: 476 } },
            { t: 'DescrWrapper', p: 'h', v: { 0: 94, 1: 320 } },
            { t: 'DescrLarge', p: 'alpha', v: { 0: 0, 1: 1 } },
            { t: 'DescrSmall', p: 'alpha', v: { 0: 1, 1: 0 } },
            {
              t: 'Readmore',
              p: 'buttonText',
              v: { 0: Language.translate('Readmore'), 1: Language.translate('Readless') },
            },
          ],
        })
      }
    })
  }

  _handlePlay() {
    if (!VideoPlayer.playing || VideoPlayer.src !== this._item.streamUrl) {
      this.widgets.globalplayer.onPlayerUpdate({
        state: 'startplay',
        list: [{ url: this._item.streamUrl }],
        startIndex: 0,
        type: 'playlist',
        listType: 'episode',
        item: this._item,
      })
    }
  }

  _handleStop() {
    if (VideoPlayer.playing) {
      VideoPlayer.close()
    }
  }

  _active() {
    this._setState('PlayButton')
  }
  OnGpStateChange({ playbuttonState }) {
    this.tag('PlayButton').OnGpStateChange({ playbuttonState })
  }
  _inactive() {
    this.stage.gc()
  }
  playbackError() {
    this.widgets.errorbox.alpha = 1
    this.widgets.errorbox.notify({ type: 'playbackStopped', Notification: true })
    Router.focusWidget('ErrorBox')
  }

  _startReadMore(show) {
    let scrollerAlpha = show === true ? 1 : 0
    if (this._showScroller === false) {
      scrollerAlpha = 0
    }
    this.tag('DescrLarge').setScrollerAlpha = scrollerAlpha
    if (show === true) {
      this._expandAnimation.start()
    } else {
      this._expandAnimation.stop()
    }

    this._descrCollaps = show !== true
  }

  static _states() {
    return [
      class Idle extends this {},

      class PlayButton extends this {
        $enter() {
          if (this._autoPlay) {
            this._handleEnter()
            this._autoPlay = false
          }
        }

        _handleLeft() {
          if (this._descrCollaps === false && this._showScroller === true) {
            this._setState('DescrLarge')
          } else {
            Router.focusWidget('SideMenu')
          }
        }

        _handleRight() {
          this._setState('MoreButton')
        }

        _handleEnter() {
          let currentStream = ''
          currentStream = VideoPlayer.src

          let isSameStream = currentStream === this._item.streamUrl

          if (VideoPlayer.playing && isSameStream) {
            this.widgets.globalplayer.onPlayerUpdate({
              state: 'stop',
              list: [{ url: this._item.streamUrl }],
              startIndex: 0,
              type: 'playlist',
              listType: 'episode',
              item: this._item,
            })
          } else {
            this.widgets.globalplayer.onPlayerUpdate({
              state: 'startplay',
              list: [{ url: this._item.streamUrl }],
              startIndex: 0,
              type: 'playlist',
              listType: 'episode',
              item: this._item,
            })
          }
        }

        _getFocused() {
          return this.tag('PlayButton')
        }
      },

      class MoreButton extends this {
        _handleLeft() {
          this._setState('PlayButton')
        }

        _handleEnter() {
          if (this._descrCollaps === true) {
            this._startReadMore(true)

            if (this._showScroller === true) {
              this._setState('DescrLarge')
            }
          } else {
            this._startReadMore(false)
          }
        }

        _getFocused() {
          return this.tag('Readmore')
        }
      },

      class DescrLarge extends this {
        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _handleRight() {
          this._setState('PlayButton')
        }

        _getFocused() {
          return this.tag('DescrLarge')
        }
      },
    ]
  }
}
